<template>
  <div v-if="!isPublic">
    <p-button
      v-if="!hasAccess"
      class="content-locked-button ix-1 pb-1"
      tertiary
      :title="$t('learnit.baseData.button.unlockContent')"
      @click="$router.push('/ktgl/learnit/users/accessCode')"
    >
      <p-icon>
        lock
      </p-icon>
    </p-button>
    <!-- <div v-else class="ix-1" readonly :title="$t('learnit.baseData.status.nonPublicUnlockedInfo')">
      <p-icon>
        lock_open
      </p-icon>
    </div> -->
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    name: 'KtglLearningLock',
    props: {
      isPublic: { type: Boolean, default: false },
    },
    data: () => ({
      cardSummaryMaxLength: 200,
    }),
    computed: {
      hasAccess(): boolean {
        return this.$service.api.users.getHasAccessToContent(this.isPublic);
      },
    },
  });
</script>
